import React, { useState, useCallback } from "react";
import { browserHistory } from "react-router";
import ProgramBreadcrumbsHeader from "../common/ProgramBreadcrumbsHeader";
import { ChatLocations, ChatShluchim, ChatStudents } from "./details";
import AuthService, { PermissionClaims } from "../../services/AuthService";
import { Unauthorized } from "../../lib/coc-common-components";

const chatTabs = [
  { title: "Locations", component: ChatLocations },
  { title: "Shluchim", component: ChatShluchim },
  { title: "Students", component: ChatStudents },
];

export default function ChatSystem({ location, params: { scheduleId } }) {
  const [tabIndex, setTabIndex] = useState(Number(location.query.tab) || 0);

  const onClickTab = useCallback(
    (index) => {
      setTabIndex(index);
      browserHistory.replace(`${location.pathname}?tab=${index}`);
    },
    [location.pathname],
  );

  if (!AuthService.UserHasClaim(PermissionClaims.ChatAdminView)) {
    return <Unauthorized userName={AuthService.getCurrentUser().name} />;
  }

  const allowEdit = AuthService.UserHasClaim(PermissionClaims.ChatAdminEdit);

  return (
    <div className="engagement-page page container">
      <ProgramBreadcrumbsHeader scheduleId={scheduleId} />
      <div className="chat-details-tabs">
        {chatTabs.map((tab, index) => (
          <p
            key={index}
            className={`large-text ${tabIndex === index ? "active" : ""}`}
            onClick={() => onClickTab(index)}
          >
            {tab.title}
          </p>
        ))}
      </div>
      <div className="card">
        {React.createElement(chatTabs[tabIndex].component, { allowEdit })}
      </div>
    </div>
  );
}
